import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/bscClaimRecordYuanxi',
    PaymentArrivePeoplePage(query){
        return http({
            url: this.baseurl + '/paymentArrivePeoplePage',
            method: 'post',
            params: query
        });
    },
    ExportPaymentPeopleList(query) {
        return http({
            url: this.baseurl + '/exportPaymentPeopleList',
            method: 'post',
            params: query,
            responseType: 'blob'
        });
    },
}
